import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AgentsUserDetail from './components/AgentsUserDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageAgentsUser',
  components: {
    AgentsUserDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;